/**
 * 404 Not Found Page
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import { makeStyles, tokens, Text, Button, Card } from "@fluentui/react-components";
import { DocumentError24Regular } from "@fluentui/react-icons";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    padding: tokens.spacingVerticalXXL,
  },
  card: {
    maxWidth: "400px",
    textAlign: "center",
    padding: tokens.spacingVerticalXXL,
  },
  icon: {
    fontSize: "64px",
    color: tokens.colorNeutralForeground3,
    marginBottom: tokens.spacingVerticalL,
  },
  title: {
    marginBottom: tokens.spacingVerticalS,
  },
  description: {
    color: tokens.colorNeutralForeground3,
    marginBottom: tokens.spacingVerticalL,
  },
});

export const NotFoundPage: React.FC = () => {
  const styles = useStyles();
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <Card className={styles.card}>
        <DocumentError24Regular className={styles.icon} />
        <Text size={700} weight="semibold" block className={styles.title}>
          Page Not Found
        </Text>
        <Text className={styles.description}>
          The page you're looking for doesn't exist or has been moved.
        </Text>
        <Button appearance="primary" onClick={() => navigate("/")}>
          Go to Home
        </Button>
      </Card>
    </div>
  );
};

export default NotFoundPage;
